<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19qsibx/tc-custom/9781453290361.jpg?1704761435004" alt="This image is the cover for the book Killed on the Rocks, The Matt Cobb Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Killed on the Rocks, The Matt Cobb Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>At a snowed-in retreat, a corporate takeover turns deadly</b><br/>A remote mansion, a blizzard, and lack of phone service: It’s an opportunity a killer can’t pass up. Matt Cobb, the in-house troubleshooter for a television conglomerate, is summoned to an executive meeting at the Adirondack home of billionaire G. B. Dost. Dost plans to acquire the TV network, and the shareholders are anxious about the rich man’s intentions. One of the bigwigs might even prefer murder to a takeover.  Sure enough, the morning before negotiations would start, Dost is discovered dead outside his lodge—surrounded by forty feet of smooth, unbroken snow—and Cobb is faced with the task of interrogating guests. And matters are only complicated by Dost’s psychic wife, his off-kilter son, and a haunting message somehow relayed on a television found to be unplugged. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        William L. DeAndrea
      </h2>
      
      <p class="authorDescription body article">William L. DeAndrea (1952&ndash;1996) was born in Port Chester, New York. While working at the Murder Ink bookstore in New York City, he met mystery writer Jane Haddam, who became his wife. His first book, <i>Killed in the Ratings</i> (1978), won an Edgar Award in the best first mystery novel category. That debut launched a series centered on Matt Cobb, an executive problem-solver for a TV network who unravels murders alongside corporate foul play. DeAndrea&rsquo;s other series included the Nero Wolfe&ndash;inspired Niccolo Benedetti novels, the Clifford Driscoll espionage series, and the Lobo Blacke/Quinn Booker Old West mysteries. A devoted student of the mystery genre, he also wrote a popular column for the<i> Armchair Detective</i> newsletter. One of his last works, the Edgar Award&ndash;winning <i>Encyclopedia Mysteriosa</i> (1994), is a thorough reference guide to sleuthing in books, film, radio, and TV.&#160; &#160; &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?13adb8cf